import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 p-2 text-xs text-gray-500">
      <div className="flex justify-between items-center">
        <div>
          <span>OpenManus with UI. appreciate @mannaandpoem project</span>
        </div>
        <div>
          <span>version 1.0.0</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
